module.exports = __webpack_public_path__ + "static/img/training-icon.3add8a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/tools/training-icon.png
// module id = 76Ig
// module chunks = 0